<template>
  <div>
    <div>
      <b-form-input v-model="textFilter"
                    type="text"
                    class="mb-1"
                    id="store-input-search"
                    placeholder="Buscar Producto"></b-form-input>
    </div>
    <Loader v-if="loading"></Loader>
    <b-list-group v-else>
      <b-list-group-item list-group-item-action class="pointer" v-for="list in filteredProducts" :key="list.product_map_id">
        <b-card class="border-0">
          Información producto proveedor
          <h6>{{list.vendor_product_description}}</h6>
          <h6>{{list.vendor_product_code}}</h6>
          Información producto cadena
          <h6>{{list.retail_product_description}}</h6>
          <h6>{{list.retail_product_code}}</h6>
        </b-card>
        <b-card class="text-center border-0">
          <b-row>
            <b-col cols="6">
              Venta en unidades
              <h6>{{list.quantity_sold | number}}</h6>
            </b-col>
            <b-col cols="6">
              Stock en Unidades
              <h6>{{list.stock_quantity | number}}</h6>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="6">
              Venta en $
              <h6>{{list.real_sales_amount | money}}</h6>
            </b-col>
            <b-col cols="6">
              Stock en $ (PVP)
              <h6>{{list.real_stock_pvp_amount | money}}</h6>
            </b-col>
          </b-row>
        </b-card>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>


<script>
  import { productParameters } from '../../expertoRetail/defaultPayloads/organismsMobile'
  import { sales } from '../../services/api/ExpertoRetail'
  import Loader from '@/expertoRetail/atoms/ExpertoRetailLoader'
  import { GeneralUtils } from '@/mixins/index'

  export default {
    name: 'store-detail',
    components: {
      Loader
    },
    mixins: [GeneralUtils],
    data () {
      return {
        textFilter: '',
        productDetail: {
          data: {}
        },
        loading: false,
        user_id: this.userInfo.id
      }
    },
    created () {
      this.storeListRequest()
      if (this.user_id === undefined) {
        this.$router.push('/')
      }
    },
    computed: {
      filteredProducts () {
        // If there is no filter text, just return everyone
        if (!this.textFilter) return this.productDetail.data

        // Convert the search text to lower case
        let searchText = this.textFilter.toLowerCase()

        // Use the standard javascript filter method of arrays
        // to return only people whose first name or last name
        // includes the search text
        return this.productDetail.data.filter(p => {
          // if IE support is required and not pre-compiling,
          // use indexOf instead of includes
          return p.vendor_product_description.toLowerCase().includes(searchText) ||
            p.retail_product_description.toLowerCase().includes(searchText) ||
            p.retail_product_code.toLowerCase().includes(searchText) ||
            p.vendor_product_code.toLowerCase().includes(searchText)
        })
      },
      vuexMobileFilters () {
        return this.$store.state.mobile.mobileFilters
      },
      vuexStoreId () {
        return this.$store.state.mobile.store_id
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      storeListRequest () {
        this.loading = true
        let filterCopy = this.$_generalUtils_deepJsonCopy(this.vuexMobileFilters)
        productParameters.parameters = {...productParameters.parameters, ...filterCopy}
        productParameters.parameters.store_filters.store_id = []
        productParameters.parameters.store_filters.store_id.push(this.vuexStoreId.toString())
        return new Promise((resolve, reject) => {
          let vm = this
          sales.salesTwoRanges(productParameters)
            .then(response => {
              vm.productDetail.data = response.data
              resolve()
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              vm.loading = false
            })
        })
      }
    }
  }
</script>


<style scoped>
  .bk-color {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#1e5799+0,25146d+0,3f137c+73,50327a+98 */
    background: #0d1052; /* Old browsers */
  }
  .transparent {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/ExpertoRetailMobileProductList.vue